<template>
  <div class="enterprise-info-page">
    <div class="page-header">
      <div class="header-left">
        <span class="header-item">企业盘雷ID：{{ enterpriseHeaderId }}</span>
        <span class="header-item">企业名称：{{ enterpriseHeaderName }}</span>
      </div>
      <div class="btn">
        <el-button link size="small" @click="handlePrimaryAction">
          <el-icon><Edit /></el-icon>
          <span>{{ isEditing ? '保存' : '编辑' }}</span>
        </el-button>
      </div>
    </div>

    <div v-if="showIntroSection" class="module">
      <div class="module-title">
        <span class="module-text">企业基本介绍</span>
        <span class="module-tip">（请确保发布信息真实、准确且不侵犯第三方权益）</span>
      </div>
      <div class="intro-content">
        {{ introText }}
      </div>
    </div>

    <div class="module">
      <div class="module-title">
        公司图片资料<span class="module-tip">（上传后自动保存）</span>
      </div>

      <div class="upload-row">
        <span class="upload-label">公司资质：</span>
        <div class="upload-content">
          <upload-file
            v-model="qualificationIds"
            is-type="add"
            list-type="picture-card"
            :limit="10"
            :list="qualificationFileList"
            accept="image/*"
            :max-size-mb="10"
            :only-image="true"
            :after-success="handleQualificationUploadSuccess"
            :after-delete="handleQualificationDelete"
          />
          <span class="upload-tip">最多10张，上传10M以下图片</span>
        </div>
      </div>

      <div class="upload-row upload-row--last">
        <span class="upload-label">公司办公车间环境：</span>
        <div class="upload-content">
          <upload-file
            v-model="workshopIds"
            is-type="add"
            list-type="picture-card"
            :limit="10"
            :list="workshopFileList"
            accept="image/*"
            :max-size-mb="10"
            :only-image="true"
            :after-success="handleWorkshopUploadSuccess"
            :after-delete="handleWorkshopDelete"
          />
          <span class="upload-tip">最多10张，上传10M以下图片</span>
        </div>
      </div>
    </div>

    <div class="module">
      <div class="module-title">
        企业信息<span class="module-tip"></span>
      </div>
      <el-form :model="formData" label-width="200px" class="enterprise-form" label-position="right">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="官网地址：">
              <el-input v-model="formData.website" :disabled="!isEditing" placeholder="请输入官网地址" style="width: 400px" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="详细地址：">
              <el-input v-model="formData.detailAddress" :disabled="!isEditing" placeholder="请输入详细地址" style="width: 400px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="办公区域：">
              <el-cascader
                v-model="formData.officeArea"
                :options="areaOptions"
                :props="{ expandTrigger: 'hover' }"
                :disabled="!isEditing"
                style="width: 400px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮编：">
              <el-input v-model="formData.zipCode" :disabled="!isEditing" placeholder="请输入邮编" style="width: 400px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="统一社会信用代码：">
              <el-input
                v-model="formData.creditCode"
                :disabled="!isEditing"
                placeholder="请输入统一社会信用代码"
                style="width: 400px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="注册时间：">
              <el-input v-model="formData.registerTime" :disabled="!isEditing" placeholder="请输入注册时间" style="width: 400px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="注册资本：">
              <el-input
                v-model="formData.registeredCapital"
                :disabled="!isEditing"
                placeholder="请输入注册资本"
                style="width: 400px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="营业期限结束时间：">
              <el-input
                v-model="formData.businessEndTime"
                :disabled="!isEditing"
                placeholder="请输入营业期限结束时间"
                style="width: 400px"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="营业期限开始时间：">
              <el-input
                v-model="formData.businessStartTime"
                :disabled="!isEditing"
                placeholder="请输入营业期限开始时间"
                style="width: 400px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="组织机构代码：">
              <el-input
                v-model="formData.organizationCode"
                :disabled="!isEditing"
                placeholder="请输入组织机构代码"
                style="width: 400px"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="税务登记号：">
              <el-input
                v-model="formData.taxRegistrationNo"
                :disabled="!isEditing"
                placeholder="请输入税务登记号"
                style="width: 400px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="企业类型：">
              <el-input v-model="formData.enterpriseType" :disabled="!isEditing" placeholder="请输入企业类型" style="width: 400px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="企业法人：">
              <el-input v-model="formData.legalPerson" :disabled="!isEditing" placeholder="请输入企业法人" style="width: 400px" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="传真号：">
              <el-input v-model="formData.faxNo" :disabled="!isEditing" placeholder="请输入传真号" style="width: 400px" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="注册地址：">
              <el-input v-model="formData.registerAddress" :disabled="!isEditing" placeholder="请输入注册地址" style="width: 400px" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="年营业额：">
              <el-select v-model="formData.annualTurnover" :disabled="!isEditing" placeholder="请选择年营业额" style="width: 400px">
                <el-option label="500万以下" value="below500w" />
                <el-option label="500万-1000万" value="500w-1000w" />
                <el-option label="1000万-5000万" value="1000w-5000w" />
                <el-option label="5000万以上" value="above5000w" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="员工人数：">
              <el-select v-model="formData.employeeCount" :disabled="!isEditing" placeholder="请选择员工人数" style="width: 400px">
                <el-option label="10人以下" value="below10" />
                <el-option label="10-50人" value="10-50" />
                <el-option label="50-100人" value="50-100" />
                <el-option label="100人以上" value="above100" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { Edit } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import uploadFile from '@/components/publicComponent/uploadFile.vue'
import area from '@/common/json/area.json'
import { handleTreeData } from '@/common/js/common.js'

const props = defineProps({
  enterpriseDetail: {
    type: Object,
    default: () => ({})
  }
})

const store = useStore()
const showIntroSection = false
const isEditing = ref(false)
const defaultIntroText = '企业介绍信息暂未维护。'
const areaOptions = handleTreeData(area, 'name', 'name')

const qualificationFileList = ref([])
const workshopFileList = ref([])
const qualificationIds = ref([])
const workshopIds = ref([])

const createDefaultFormData = () => ({
  website: '',
  officeArea: [],
  creditCode: '',
  registeredCapital: '',
  businessStartTime: '',
  taxRegistrationNo: '',
  legalPerson: '',
  registerAddress: '',
  employeeCount: '',
  detailAddress: '',
  zipCode: '',
  registerTime: '',
  businessEndTime: '',
  organizationCode: '',
  enterpriseType: '',
  faxNo: '',
  annualTurnover: ''
})

const formData = reactive(createDefaultFormData())
const enterpriseDetail = ref({})

const enterpriseHeaderId = computed(() => {
  return enterpriseDetail.value.enterpriseCode || enterpriseDetail.value.enterpriseId || enterpriseDetail.value.id || '--'
})

const enterpriseHeaderName = computed(() => {
  return enterpriseDetail.value.enterpriseName || '--'
})

const introText = computed(() => {
  return (
    enterpriseDetail.value.enterpriseIntro ||
    enterpriseDetail.value.enterpriseProfile ||
    enterpriseDetail.value.businessScope ||
    defaultIntroText
  )
})

const parseFileList = value => {
  if (!value) {
    return []
  }
  if (Array.isArray(value)) {
    return value
  }
  if (typeof value === 'string') {
    try {
      const parsedValue = JSON.parse(value)
      return Array.isArray(parsedValue) ? parsedValue : []
    } catch (error) {
      return []
    }
  }
  return []
}

const getExistingFileIds = files =>
  (files || []).map(item => item.fileId || item.id || item.uid).filter(Boolean)

const stringifyFileIds = ids =>
  (ids || []).map(item => String(item).trim()).filter(Boolean).join(',') || null

const getSingleAttachmentId = value => {
  if (!value) {
    return null
  }
  if (Array.isArray(value)) {
    return getExistingFileIds(value)[0] || null
  }
  if (typeof value === 'object') {
    return value.fileId || value.id || value.uid || null
  }
  if (typeof value === 'string') {
    const trimmedValue = value.trim()
    if (!trimmedValue) {
      return null
    }
    try {
      const parsedValue = JSON.parse(trimmedValue)
      return getSingleAttachmentId(parsedValue)
    } catch (error) {
      return trimmedValue.split(',').map(item => item.trim()).filter(Boolean)[0] || null
    }
  }
  return String(value)
}

const getFileIdsFromUploadList = files =>
  (files || [])
    .map(item => item.response?.data?.fileId || item.fileId || item.id)
    .filter(Boolean)

const mapEnterpriseDetailToForm = detail => {
  return {
    ...createDefaultFormData(),
    website: detail.website || '',
    officeArea: detail.province ? [detail.province, detail.city, detail.district] : [],
    creditCode: detail.socialCreditCode || '',
    registeredCapital: detail.registeredCapital || '',
    businessStartTime: detail.startBusinessTime || '',
    taxRegistrationNo: detail.taxRegisteredCertificate || '',
    legalPerson: detail.legalPersonName || '',
    registerAddress: detail.enterpriseAddr || '',
    employeeCount: detail.staffNum || '',
    detailAddress: detail.address || '',
    zipCode: detail.zipCode || detail.postCode || detail.postalCode || '',
    registerTime: detail.establishedTime || '',
    businessEndTime: detail.endBusinessTime || '',
    organizationCode: detail.organizationCode || '',
    enterpriseType: detail.enterpriseOcrType || detail.enterpriseType || '',
    faxNo: detail.fax || '',
    annualTurnover: detail.annualTurnover || ''
  }
}

const applyEnterpriseDetail = detail => {
  const nextDetail = detail || {}
  enterpriseDetail.value = nextDetail
  qualificationFileList.value = parseFileList(nextDetail.enterpriseQualification)
  workshopFileList.value = parseFileList(nextDetail.officeWorkshopEnvironment)
  qualificationIds.value = getExistingFileIds(qualificationFileList.value)
  workshopIds.value = getExistingFileIds(workshopFileList.value)
  Object.assign(formData, mapEnterpriseDetailToForm(nextDetail))
}

const loadEnterpriseInfo = async enterpriseId => {
  const res = await store.dispatch('myMessageModule/getEnterprise', enterpriseId)
  const { code, data = {} } = res?.data || {}
  if (code !== '0') {
    return
  }

  applyEnterpriseDetail(data)
}

const buildSubmitPayload = () => {
  const payload = {
    ...enterpriseDetail.value,
    enterpriseId: enterpriseDetail.value.id || enterpriseDetail.value.enterpriseId,
    website: formData.website,
    address: formData.detailAddress,
    areas: [...formData.officeArea],
    postalCode: formData.zipCode,
    socialCreditCode: formData.creditCode,
    registeredCapital: formData.registeredCapital,
    startBusinessTime: formData.businessStartTime,
    taxRegisteredCertificate: formData.taxRegistrationNo,
    legalPersonName: formData.legalPerson,
    enterpriseAddr: formData.registerAddress,
    staffNum: formData.employeeCount,
    establishedTime: formData.registerTime,
    endBusinessTime: formData.businessEndTime,
    organizationCode: formData.organizationCode,
    enterpriseOcrType: formData.enterpriseType,
    fax: formData.faxNo,
    annualTurnover: formData.annualTurnover,
    enterpriseLicense: getSingleAttachmentId(enterpriseDetail.value.enterpriseLicense),
    sealFlies: getSingleAttachmentId(enterpriseDetail.value.sealFlies),
    collectionQrCode: getSingleAttachmentId(enterpriseDetail.value.collectionQrCode),
    enterpriseQualification: stringifyFileIds(qualificationIds.value),
    officeWorkshopEnvironment: stringifyFileIds(workshopIds.value)
  }

  payload.province = payload.areas[0] || ''
  payload.city = payload.areas[1] || ''
  payload.district = payload.areas[2] || ''
  delete payload.areas

  return payload
}

const buildMediaPayload = extraPayload => {
  const detail = JSON.parse(JSON.stringify(enterpriseDetail.value))
  return {
    ...detail,
    enterpriseId: detail.id || detail.enterpriseId,
    enterpriseLicense: getSingleAttachmentId(detail.enterpriseLicense),
    sealFlies: getSingleAttachmentId(detail.sealFlies),
    collectionQrCode: getSingleAttachmentId(detail.collectionQrCode),
    enterpriseQualification: stringifyFileIds(qualificationIds.value),
    officeWorkshopEnvironment: stringifyFileIds(workshopIds.value),
    ...extraPayload
  }
}

const init = async () => {
  if (props.enterpriseDetail && Object.keys(props.enterpriseDetail).length) {
    applyEnterpriseDetail(props.enterpriseDetail)
    return
  }

  const userRes = await store.dispatch('myMessageModule/getUser')
  const { code, data = {} } = userRes?.data || {}
  if (code !== '0' || !data.enterpriseId) {
    return
  }

  await loadEnterpriseInfo(data.enterpriseId)
}

const saveEnterpriseInfo = async () => {
  const payload = buildSubmitPayload()
  const res = await store.dispatch('myMessageModule/editEnterprise', payload)
  if (res?.data?.code !== '0') {
    return
  }

  ElMessage.success('保存成功')
  isEditing.value = false
  await loadEnterpriseInfo(enterpriseDetail.value.id || enterpriseDetail.value.enterpriseId)
}

const saveEnterpriseMedia = async (payload, successMessage) => {
  const res = await store.dispatch('myMessageModule/editEnterprise', payload)
  if (res?.data?.code !== '0') {
    return
  }

  ElMessage.success(successMessage)
  await loadEnterpriseInfo(enterpriseDetail.value.id || enterpriseDetail.value.enterpriseId)
}

const handleQualificationUploadSuccess = async (info, fileList) => {
  qualificationIds.value = getFileIdsFromUploadList(fileList)
  await saveEnterpriseMedia(
    buildMediaPayload({
      enterpriseQualification: stringifyFileIds(qualificationIds.value)
    }),
    '公司资质保存成功'
  )
}

const handleQualificationDelete = async (file, fileList) => {
  qualificationIds.value = getFileIdsFromUploadList(fileList)
  await saveEnterpriseMedia(
    buildMediaPayload({
      enterpriseQualification: stringifyFileIds(qualificationIds.value)
    }),
    '公司资质保存成功'
  )
}

const handleWorkshopUploadSuccess = async (info, fileList) => {
  workshopIds.value = getFileIdsFromUploadList(fileList)
  await saveEnterpriseMedia(
    buildMediaPayload({
      officeWorkshopEnvironment: stringifyFileIds(workshopIds.value)
    }),
    '公司办公车间环境保存成功'
  )
}

const handleWorkshopDelete = async (file, fileList) => {
  workshopIds.value = getFileIdsFromUploadList(fileList)
  await saveEnterpriseMedia(
    buildMediaPayload({
      officeWorkshopEnvironment: stringifyFileIds(workshopIds.value)
    }),
    '公司办公车间环境保存成功'
  )
}

const handlePrimaryAction = async () => {
  if (!isEditing.value) {
    isEditing.value = true
    return
  }

  await saveEnterpriseInfo()
}

onMounted(() => {
  init()
})

watch(
  () => props.enterpriseDetail,
  detail => {
    if (detail && Object.keys(detail).length) {
      applyEnterpriseDetail(detail)
    }
  },
  { deep: true }
)
</script>

<style lang="less">
.enterprise-info-page {
  padding: 24px;
  background: #ffffff;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;

  .btn {
    display: flex;
    margin-left: 40px;
    align-items: center;

    .el-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      color: #48a09c;
      border: none !important;
      outline: none;

      span {
        display: inline-flex;
      }
    }
  }
}

.header-left {
  display: flex;
  gap: 200px;
}

.header-item {
  font-size: 16px;
  color: #303133;
}

.module {
  margin-bottom: 32px;
}

.module-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  padding-left: 8px;
  border-left: 3px solid #369a9a;
  margin-bottom: 16px;
  min-height: 40px;
  line-height: 40px;
}

.module-tip {
  font-size: 14px;
  color: #919696;
  font-weight: 400;
}

.module-text {
  line-height: 40px;
}

.intro-content {
  background-color: #f5f7fa;
  padding: 16px;
  border-radius: 4px;
  font-size: 14px;
  color: #333333;
  line-height: 1.6;
  white-space: pre-wrap;
}

.enterprise-form {
  margin-top: 16px;
}

.upload-row {
  display: flex;
  align-items: flex-start;
  padding: 18px 0;
  border-bottom: 1px solid #eeeeee;
}

.upload-row--last {
  border-bottom: none;
  padding-bottom: 0;
}

.upload-label {
  width: 160px;
  flex: 0 0 160px;
  font-size: 14px;
  color: #333333;
  line-height: 32px;
}

.upload-content {
  flex: 1;
  min-width: 0;
}

.upload-tip {
  display: inline-block;
  margin-top: 12px;
  color: #919696;
  font-size: 13px;
  line-height: 20px;
}

:deep(.el-form-item__label) {
  font-size: 14px;
  color: #333333;
}

:deep(.el-input__placeholder),
:deep(.el-select .el-input__placeholder) {
  color: #c0c4cc;
}

:deep(.el-input),
:deep(.el-select) {
  width: 100%;
}
</style>
